import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import BodyFont from '../../Theme/Fonts/Body'
import BigHeadlineFont from '../../Theme/Fonts/BigHeadline'
import BigButton from '../../BaseComponents/Button/Standard/Big'
import { TestID } from '../../utils/PropTypesDefinitions'

export type ErrorFullscreenProps = {
    errorMessage: string
    errorIcon?: 'error' | 'wifi-problem'
    buttonText?: string
    onReload?: () => void
} & TestID

const ErrorFullscreen: FunctionComponent<ErrorFullscreenProps> = ({
    errorMessage,
    errorIcon = 'error',
    buttonText,
    onReload,
    testID,
}): ReactElement => {
    return (
        <Grid center noExpand testID={testID} backgroundColor="pearl">
            <FontelloIcon name={errorIcon} fontSize={131} marginBottom={42} color="onyx" />
            <BigHeadlineFont color="onyx">Ooops!</BigHeadlineFont>
            <Grid noExpand marginBottom={6} marginTop={5}>
                <BodyFont color="onyx" textAlign="center" bold>
                    {errorMessage}
                </BodyFont>
            </Grid>
            {buttonText && onReload ? (
                <Grid noExpand marginTop={6}>
                    <BigButton backgroundColor="onyx" onPress={onReload}>
                        {buttonText}
                    </BigButton>
                </Grid>
            ) : null}
        </Grid>
    )
}

export default memo(ErrorFullscreen)
